import isArray from "lodash/isArray";

export class ApiService {
  constructor(API_ENDPOINT, $cookies, $http) {
    "ngInject";

    this.$http = $http;
    this.$http.defaults.cache = false;
    this.$cookies = $cookies;
    this.API_ENDPOINT = API_ENDPOINT;
    this.setDefaultHeaders();
  }

  setDefaultHeaders(headerVal) {
    this.$http.defaults.headers.common["Authorization"] = headerVal;
  }

  removeDefaultHeaders() {
    this.$http.defaults.headers.common["Authorization"] = undefined;
  }

  getResourceUrl(path) {
    return this.API_ENDPOINT + path;
  }

  getImageUrl(path) {
    const token = this.$cookies.get("token");
    return path ? `${this.API_ENDPOINT}/file/${path}?token=${token}` : null;
  }

  getPreviewImageUrl(path) {
    return path ? `${this.API_ENDPOINT} v1/file/${path}/preview` : null;
  }

  getPdfUrl(path) {
    return path ? this.API_ENDPOINT + "upload-pdf/" + path : null;
  }

  titleCase(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  getErrorMessage(details) {
    if (details.status === 500) {
      return "Something went wrong";
    } else {
      if (isArray(details.data.message)) {
        return details.data.message[0];
      } else {
        const errorMsg = this.titleCase(details.data.errors.message);
        return errorMsg;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/libs/api/api.service.js